import {globals, globalUser} from "../modules/globals.js";
import {newGameMenuButtonHandler, playScenarioHandler} from "./scenarios.js";
import {
    continueGameMenuButtonHandler,
    deleteCloudSave,
    importCloudSave,
    importCloudSavesMenuButtonHandler,
    importMainGameSave,
    importMainGameSavesMenuButtonHandler, loadGameFromCompressedSaveData,
    selectGameToPlayHandler
} from "./games.js";
import {playSoundEffect} from "./sounds.js"
import {
    escapeHTML,
    getTalentRequestTypesHelpHtml,
    getTraitHelpHtml,
    hideMainMenuContent,
    makeGameRequest,
    makeGetRequest, showFormattedDisplayName
} from "./ui-helpers.js";
import {addPaidFeatures, deleteGameRequest, getUserInfo, removePaidFeatures} from "../modules/games.js";
import {traitsData} from "../data/traits.js";
import {talentRequestsData} from "../data/talentRequests.js";
import {changeCharacterBackgroundImage} from "./graphics.js";
import './community.js';
import {changeUserSettingRequest} from "./manage-sub-menu.js";
import {loadUser, saveUser, syncUserData} from "../modules/user.js";
import {setupSetManagersForMatchOrSegment} from "../modules/managers.js";
import {setupCreateFaction} from "../modules/factions.js";
import {setupGetRankingDataForYear} from "../modules/rankings.js";
import {setupCreateTalentRequest} from "../modules/talentRequests.js";
import {createScenarioMenuButtonHandler} from "./scenarioEditor.js";
import {loadHomePage} from "./home-page.js";
import {gameLimits, getCurrentGame, getTimeDiffHuman} from "../modules/helpers.js";
import {Games, loadDb} from "../models/models.js";
import {copyToClipboard} from "./graphics.js";

$(document).ready(async function () {

    // Check if browser is not supported
    if (navigator.userAgent.match(/SamsungBrowser/i)) {
        notie.alert({
            type: 3, text: 'Your browser is not supported. Please try playing on another browser like Chrome.',
            stay: true
        });
        throw new Error('Browser not supported');
    }

    let user = await setupUser();

    // Setup other config
    if (navigator.storage) {
        await navigator.storage.persist();
    }
    $('input').attr('autocomplete','off');
    notie.setOptions({
        alertTime: 6
    });

    // Setup sentry
    if (typeof window.Sentry !== 'undefined') {
        Sentry.init({
            dsn: "https://29edf8d19433a6d905e2f4c44c3b4074@o73522.ingest.sentry.io/158367",
            beforeSend: function (event, hint) {
                // filter out UnhandledRejection errors that have no information
                if (event !== undefined && event.exception !== undefined && event.exception.values !== undefined
                    && event.exception.values.length === 1) {
                    let e = event.exception.values[0];
                    if (e.type === 'UnhandledRejection' && e.value === 'Non-Error promise rejection captured with value: ') {
                        return null;
                    }
                }
            },
            ignoreErrors: [
                'NotSupportedError', 'AbortError', 'NotAllowedError',
                'null is not an object (evaluating \'d.frameElement\')', 'Object expected',
                'Cannot read property \'frameElement\' of null', 'TagError', 'Extension context invalidated',
                'undefined is not an object (evaluating \'c.left\')',
                'null is not an object (evaluating \'e.target.parentNode.classList\')', 'Cannot read property \'left\' of undefined',
                'JSON syntax error',
                'TypeError: undefined is not an object (evaluating \'window.webkit.messageHandlers.selectedDebugHandler.postMessage\')',
                'undefined is not an object (evaluating \'window.webkit.messageHandlers.selectedTextHandler.postMessage\')',
                'Non-Error promise rejection captured with keys: message',
                'UnknownError: Cannot inject key into script value',
                'Cannot inject key into script value',
	            't.prototype._onMouseMove(src/accessibility/AccessibilityManager)',
	            't.prototype._onMouseMove(src/accessibility/AccessibilityManager)',
                'Event `ErrorEvent` captured as exception with message `Script error.`'
            ],
            whitelistUrls: [
                'www.journeyofwrestling.com',
                'www.journeyofwrestling.com/static',
                'journeyofwrestling.com',
                'journeyofwrestling.com/static',
            ],
            blacklistUrls: []
        });
    }

    // Load google fonts for pixi
    window.WebFontConfig = {
        custom: {
            families: ['Oswald', 'Quantico', 'Saira Stencil One', 'Orbitron', 'Cinzel Decorative', 'Cantarell',
                'Mukta Mahee']
        }
    };

    // Include the web-font loader script
    (function () {
        const wf = document.createElement('script');
        wf.src = `static/www/static/webfont.js`;
        wf.type = 'text/javascript';
        wf.async = 'true';
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(wf, s);
    }());

    // Confirm exit if scenario editor open
    function areYouSure() {
        if ($('.scenario-editor-container').is(':visible')) {
            return "Are you sure you wish to leave?";
        }
    }
    window.onbeforeunload = areYouSure;

    // Save patreon superstars and supporters to local storage if online
    if (window.navigator.onLine) {
        makeGetRequest('/_get_offline_data', {}, async (data) => {
            window.localStorage.setItem('patreonSuperstarsData', JSON.stringify(data['patreon_superstars']));
            window.localStorage.setItem('supportersData', JSON.stringify(data['supporters']));
        }, true, null, false);
    }

    // 'Continue' main menu button
    $("#continue-game").on('click', '', function () {
        if (globals.requestRunning) {
            return false;
        }
        if ($('.scenario-editor-container').is(':visible')) {
            notie.confirm({
                text: 'Are you sure you want to leave the scenario editor?',
                submitCallback: function () {
                    return continueGameMenuButtonHandler()
                },
                cancelCallback: function () {
                    $('#main-menu-buttons').find('li').removeClass('selected');
                    $('.create-scenario-menu-button').addClass('selected');
                }
            });
        } else {
            return continueGameMenuButtonHandler();
        }
    });

    // 'New Game' main menu button
    $("#new-game").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        if ($('.scenario-editor-container').is(':visible')) {
            notie.confirm({
                text: 'Are you sure you want to leave the scenario editor?',
                submitCallback: function () {
                    return newGameMenuButtonHandler()
                },
                cancelCallback: function () {
                    $('#main-menu-buttons').find('li').removeClass('selected');
                    $('.create-scenario-menu-button').addClass('selected');
                }
            });
        }
        else {
            return newGameMenuButtonHandler();
        }
    });

    // Select main menu button
    $('#main-menu-buttons').on('click', 'li:not(.button-dropdown)', function () {
        // Select this button
        $('#main-menu-buttons').find('li').removeClass('selected');
        $(this).addClass('selected');

        // Blur background image
        $('.main-container').addClass('blur');
    });

    // Select game under 'Continue'
    $('#existing-games').on('click', '.select-game', function() {
        if (globals.requestRunning) {
            return false;
        }
        return selectGameToPlayHandler($(this));
    });

    // Import main game saves menu button
    $('#existing-games').on('click', '.import-main-game-saves-button', function() {
        if (globals.requestRunning) {
            return false;
        }
        if (!globalUser.loggedIn) {
            notie.alert({
                type: 4, text: 'You need to be logged in to import saves.',
                stay: true
            });
            return false;
        }
        return importMainGameSavesMenuButtonHandler();
    });

    // Import cloud saves menu button
    $('#existing-games').on('click', '.import-cloud-saves-button', function() {
        if (globals.requestRunning) {
            return false;
        }
        if (!globalUser.loggedIn) {
            notie.alert({
                type: 4, text: 'You need to be logged in to import saves.',
                stay: true
            });
            return false;
        }
        return importCloudSavesMenuButtonHandler();
    });

    // Import main game save
    $("#account-games").on('click', '.import-main-game-save', function () {
        if (globals.requestRunning) {
            return false;
        }
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        if (!globalUser.paid && userGames.length > 0) {
            notie.alert({
                type: 3, text: 'Free users are limited to one save. Please delete your current save to create a new one.',
                stay: true
            });
            return false;
        }
        let uid = $(this).closest('.game-box').attr('data-uid');
        return importMainGameSave(uid);
    });

    // Import cloud save
    $("#account-games").on('click', '.import-cloud-save', function () {
        if (globals.requestRunning) {
            return false;
        }
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        const filename = $(this).closest('.game-box').attr('data-filename');
        const gamePresent = userGames.find(x => x.dbUid === filename);

        if (!globalUser.paid && userGames.length > 0 && !gamePresent) {
            notie.alert({
                type: 3, text: 'Free users are limited to one save. Please delete your current save to create a new one.',
                stay: true
            });
            return false;
        }

        // Ask to confirm overwrite if exising save present
        if (gamePresent) {
            notie.confirm({
                text: 'This save already exists locally and will be overwritten. Are you sure you want to proceed?',
                submitCallback: async function () {
                    return importCloudSave(filename);
                }
            })
        }
        else {
            return importCloudSave(filename);
        }
    });

    // Delete cloud save
    $("#account-games").on('click', '.delete-cloud-save-button', function (e) {
        e.stopPropagation();
        if (globals.requestRunning) {
            return false;
        }
        let parent = $(this).closest('.game-box');
        let filename = $(this).closest('.game-box').attr('data-filename');
        let companyName = parent.attr('data-company-name');
        let gameYear = parent.attr('data-game-year');
        let notieText = 'Are you sure you want to delete this <span class="game-name-highlight">{0} (Year {1})</span> cloud save?'.format(companyName, gameYear);

        notie.confirm({
            text: notieText,
            submitCallback: async function () {
                notie.confirm({
                    text: 'Are you really sure? <span class="red">This cloud save will be permanently deleted</span>.',
                    submitText: 'Yes',
                    cancelText: 'No',
                    submitCallback: async function () {
                        return deleteCloudSave(filename, parent);
                    }
                });
            }
        })
    });

    // Import save
    $(document).on('change', '#import-save-input', function () {
        let reader = new FileReader();
        reader.onload = function () {
            let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
            if (!globalUser.paid && userGames.length > 0) {
                notie.alert({
                    type: 3,
                    text: 'Free users are limited to one save. Please delete your current save to create a new one.',
                    stay: true
                });
                return false;
            }
            return loadGameFromCompressedSaveData(new Uint8Array(reader.result));
        }
        reader.readAsArrayBuffer(this.files[0]);
    });

    // Back to saves
    $('#account-games').on('click', '.back-to-saves-button', function() {
        continueGameMenuButtonHandler();
    });

    // Delete game under 'Continue'
    $("#existing-games").on('click', '.delete-game-button', function (e) {
        e.stopPropagation();
        if (globals.requestRunning) {
            return false;
        }

        let parent = $(this).closest('.game-box');
        let dbUid = parent.attr('data-dbUid');
        let companyName = parent.attr('data-company-name');
        let gameYear = parent.attr('data-game-year');
        let notieText;
        if (gameYear >= 2) {
            notieText = '<span class="red">WARNING!</span> This is a save of over {0} years. Are you sure you want to delete this <span class="game-name-highlight">{1} (Year {2})</span> game?'.format(gameYear, companyName, gameYear)
        }
        else {
            notieText = 'Are you sure you want to delete this <span class="game-name-highlight">{0} (Year {1})</span> game?'.format(companyName, gameYear)
        }
        notie.confirm({
            text: notieText,
            submitText: 'Yes',
            cancelText: 'No',
            submitCallback: async function () {
                if (gameYear >= 5) {
                    notie.confirm({
                        text: 'Are you really sure? This is a long save!',
                        submitText: 'Yes',
                        cancelText: 'No',
                        submitCallback: async function () {
                            await makeGameRequest(deleteGameRequest, {dbUid}, showDeleteGameRequestData, {parent}, false)
                        }
                    });
                }
                else {
                    await makeGameRequest(deleteGameRequest, {dbUid}, showDeleteGameRequestData, {parent}, false)
                }
            }
        });
    });

    // Click 'play' on scenario under 'New Game'
    $("#container").on('click', '.play-scenario', function () {
        if (globals.requestRunning) {
            return false;
        }
        return playScenarioHandler($(this));
    });

    // Story intro continue button
    $('#container').on('click', '.intro-continue-button', async function () {
        $('#intro').hide();
        await loadHomePage(await getCurrentGame());
    });

    // 'Create' main menu button
    $(".create-scenario-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        if ($('.scenario-editor-container').is(':visible')) {
            notie.confirm({
                text: 'Are you sure? The scenario editor will reset.',
                submitCallback: function () {
                    createScenarioMenuButtonHandler()
                }
            });
        } else {
            createScenarioMenuButtonHandler();
        }
    });

    // Back to main menu button
    $("#main-menu-button").click(function () {
        playSoundEffect('success');

        // Stop running simulation
        $('#simulation-results-container').data('stopSimulation', true);
        notie.hideAlerts();

        $("#game").fadeOut('fast').promise().done(function () {
            // Reset and show main menu
            $("#main-menu, .main-header-container").fadeIn('slow');
            $('#main-menu-buttons').find('li').removeClass('selected');
            $('.main-container').removeClass('hide-background blur');
        });
    });

    // About menu button
    $("#about-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        $(".main-container").fadeOut('fast', function () {
            notie.hideAlerts();
            $(".about-container").fadeIn('fast');
        });
    });

    // About page play button
    $(".about-container-play-button").on('click', function () {
        playSoundEffect('success');
        $(".about-container").fadeOut('fast', function () {
            notie.hideAlerts();
            $(".main-container").fadeIn('fast');
            $(".main-container")[0].scrollIntoView();
            $('#main-menu-buttons').find('li').removeClass('selected');
            $('.main-container').removeClass('blur');
            hideMainMenuContent($());
            $(this).addClass('selected');
        });
    });

    // JoW Paid menu button
    $("#jow-paid-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        notie.hideAlerts();
        hideMainMenuContent($());
        $("#paid-features").fadeIn().scrollTop(0);
    });

    // Open humble bundle page
    $('.view-upgrade-button').click(function () {
        playSoundEffect('success');
        window.open("https://www.humblebundle.com/widget/v2/standalone/jow_widget/sRm2uH4QdH")
    });

    // Redeem key page
    $('.redeem-button').click(function () {
        playSoundEffect('success');
        window.location.href = globals.baseUrl + "/upgrade";
    });

    // Roadmap button
    $("#roadmap-menu-button").on('click', function () {
        playSoundEffect('success');
        hideMainMenuContent($());
        $("#roadmap-container").hide().fadeIn();
        $('.roadmap-container').scrollTop(0);
    });

    // Patreon button
    $(".support-jow-button").on('click', function () {
        playSoundEffect('success');
        notie.hideAlerts();
        window.open('https://www.patreon.com/journeyofwrestling')
    });

    // Discord menu button
    $("#discord-menu-button").on('click', function () {
        playSoundEffect('success');
        notie.hideAlerts();
        window.open('https://discord.gg/tjwJb99')
    });

    // Help menu button
    $("#help-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        hideMainMenuContent($());
        $("#help-menu-container").hide().fadeIn();
        $('.help-menu-select').val('Superstar Morale').trigger('change');
    });

    // Help menu select
    $("#help-menu-container").on('change', '.help-menu-select', function(){
        playSoundEffect('success');
        let value = $(this).val().trim();
        let html = '';
        $('.help-container-section-select').hide();

        if (value === 'Superstar Traits') {
            let traitCategories = {
                'Matches': [],
                'Segments': [],
                'Feuds': [],
                'Overness/Alignment': [],
                'Progress': [],
                'Career': [],
                'Morale': [],
                'Holy Shit Moments': [],
                'Injuries': [],
                'Gimmicks': [],
                'Backstage': [],
                'Misc': []
            }

            // Put traits into categories
            Object.keys(traitsData).forEach(function (key) {
                traitCategories[traitsData[key]['category']].push(key)
            });

            function compareTraitsFunction(a, b) {
                return traitsData[a]['order'] - traitsData[b]['order']
            }

            Object.keys(traitCategories).forEach(function (category) {

                let traitsHelpHtml = '';
                // Sort traits by order
                traitCategories[category].sort(compareTraitsFunction).forEach(function (trait) {
                    // Add html for each trait
                    traitsHelpHtml += getTraitHelpHtml(trait, traitsData[trait])
                });

                // Add to category
                let categoryHtml = '<div class="margin-bottom-25">' +
                    '<div class="display-block margin-bottom-5">' +
                    '<span class="light-grey margin-left-2 help-container-section-name">' + category + '</span>' +
                    '</div>' +
                    traitsHelpHtml +
                    '</div>';

                html += categoryHtml;
            });

            // Add section select
            let helpSectionOptions = Array.from(Object.keys(traitCategories), function (x) {
                return '<option>' + x + '</option>'
            });
            let helpSectionOptionsHtml = helpSectionOptions.join('');
            $('.help-container-section-select').html(helpSectionOptionsHtml).hide().fadeIn();
            $('.help-container-section-select').val('Matches');
        }
        else if (value === 'Superstar Morale') {
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Matches</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Winning a match increases morale while losing a match decreases it.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'Winning against a higher popularity talent leads to a larger increase in morale while losing ' +
                'to a lower popularity talent leads to a larger decrease. The increase/decrease is reduced on a ' +
                'weekly show match or if all talent are Faces of the Company.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Titles</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Winning a title increases morale while losing a title decreases it.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The increase/decrease depends on the prestige of the title. Being in a title match also increases ' +
                'morale slightly. ' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Main Event</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Being in the main event match or segment increases morale.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The increase is lower for being in the main event of a weekly show.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Hot Match/Feud/Segment</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Being a part of a hot match, feud or segment increases morale.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'Being a part of a silly segment that gets the \'Comedy Flop\' rating lowers morale.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Feuds</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Starting a feud with a significant popularity difference increases morale for ' +
                'the lower popularity talent and decreases morale for the higher popularity one.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The increase/decrease is reduced if talent are Faces of the Company.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Not Booked</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Not being booked on a monthly show decreases morale for Main Eventers.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Talent Offers</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Rejecting a talent offer decreases morale significantly.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Callups</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Calling up a talent to the main roster increases morale.' +
                '</div>' +
                '</div>';
        }
        else if (value === 'Event Hype') {
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Event Hype Boosts</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Event Hype is boosted during the event by hot matches, hot segments, debut segments involving a' +
                ' competitor\'s talent and slander segments.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'Slander segments can backfire, depending on their rating, and can lower event hype. Debuts involving ' +
                'main eventers of a competitor add a higher boost.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Match Hype</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Match hype is affected by feuds, championships, hot or stale participants, main eventers and the ' +
                'alignment of the participants.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'Match hype is boosted by streaks, gimmick match effects for the event, match contracts and tournament ' +
                'finals.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Segment Hype</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Segment hype is affected by feuds, hot or stale participants, main eventers, the action and ' +
                'entertainment points of the segment and whether there are any consequences to it.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Event Prestige</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'The higher the event prestige, the higher the base hype for the event. The top event has the highest' +
                ' base hype, and getting your company hot boosts the base hype for all events.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Packages</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Running the event package segment can affect event hype and the main event package can' +
                ' affect match hype.' +
                '</div>' +
                '</div>';
        }
        else if (value === 'Faction REP') {
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Titles</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Faction members winning Titles increases REP while losing Titles decreases it.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The change depends on the prestige of the Title.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Members</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Adding or removing faction members through Segments affects REP based on the popularity of the members ' +
                'and whether they are Hot, Stale or a Face of the Company.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The change is higher if the added or removed member is the leader.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Feuds</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Winning Faction vs Faction Feud blowoffs increases REP while losing them decreases it.' +
                '</div>' +
                '<div class="medium-dark-grey">' +
                'The change is based on the feud\'s hype.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Hot/Stale</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'Faction members becoming Hot increases REP while becoming Stale decreases it.' +
                '</div>' +
                '</div>';
            html += '<div class="morale-help-item-container dark-grey">' +
                '<div class="margin-bottom-10">' +
                '<div class="superstar-trait-color font-15px">Face of the Company</div>' +
                '</div>' +
                '<div class="margin-bottom-7">' +
                'If a faction member becomes a Face of the Company, REP increases. If they lose their Face of the Company status, REP decreases.' +
                '</div>' +
                '</div>';
        }
        else if (value === 'Talent Requests') {
            let talentRequestsDataFormatted = Object.values(talentRequestsData).map((key) => {
                return {'name': key['display_name'], 'importance': key['importance'],
                    'description': key['description']}
            });
            talentRequestsDataFormatted.sort((a, b) => a.name.localeCompare(b.name))
            html += getTalentRequestTypesHelpHtml(talentRequestsDataFormatted);
        }

        $('.help-container-items').html(html).scrollTop(0);
        $('.help-container-name').html(value);
        $('.help-container').hide().fadeIn();
    });

    // Help section select
    $("#help-menu-container").on('change', '.help-container-section-select', function(){
        let value = $(this).val();
        let parent = $('.help-container-items');
        let el = parent.find('.help-container-section-name:contains("' + value + '")');
        if (el) {
            el[0].scrollIntoView();
        }
    });

    // Support JoW menu button
    $("#support-jow-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        notie.hideAlerts();
        hideMainMenuContent($());

        let supportersData = JSON.parse(localStorage.getItem('supportersData')) || [];
        let supportersHtml = '';
        supportersData.forEach(function (supporter) {
            supportersHtml += '<div>' + supporter + '</div>'
        });
        if (!supportersData.length) {
            supportersHtml += '<div>Supporters data could not be loaded.</div>'
        }
        $('.fotc-supporters').html(supportersHtml).scrollTop(0);
        $("#support-jow").fadeIn().scrollTop(0);
    });

    // Leaderboard
    $("#leaderboard-menu-button").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        playSoundEffect('success');
        notie.hideAlerts();
        hideMainMenuContent($());

        makeGetRequest('/_get_leaderboard_stats', {}, (data) => {
            let div = '';

            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Scenarios Created</div>';
            if (data['created_scenarios'].length > 0) {
                data['created_scenarios'].forEach(function (createdScenario) {
                    div += '<div class="display-block dark-grey">' + escapeHTML(createdScenario['display_name']) +
                        '<span class="margin-left-8 light-grey">' + createdScenario['created_scenarios'] + '</span>' +
                        '</div>';
                })
            } else {
                div += '<div class="display-block dark-grey">N/A</div>';
            }
            div += '</div>';

            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Edits Created</div>';
            if (data['created_edits'].length > 0) {
                data['created_edits'].forEach(function (createdScenario) {
                    div += '<div class="display-block dark-grey">' + escapeHTML(createdScenario['display_name']) +
                        '<span class="margin-left-8 light-grey">' + createdScenario['created_edits'] + '</span>' +
                        '</div>';
                })
            } else {
                div += '<div class="display-block dark-grey">N/A</div>';
            }
            div += '</div>';

            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Community Graphics Recommendations</div>';
            if (data['template_superstar_recommendations'].length > 0) {
                data['template_superstar_recommendations'].forEach(function (templateSuperstarRecommendation) {
                    div += '<div class="display-block dark-grey">' + escapeHTML(templateSuperstarRecommendation['display_name']) +
                        '<span class="margin-left-5 light-grey">' + '<i class="fa fa-star icon-button margin-right-5 margin-left-3 community-recommendation-color"></i>' +
                        templateSuperstarRecommendation['recommendations'] + '</span>' +
                        '</div>';
                })
            } else {
                div += '<div class="display-block dark-grey">N/A</div>';
            }
            div += '</div>';

            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Community Segments Recommendations</div>';
            if (data['template_segment_recommendations'].length > 0) {
                data['template_segment_recommendations'].forEach(function (templateSegmentRecommendation) {
                    div += '<div class="display-block dark-grey">' + escapeHTML(templateSegmentRecommendation['display_name']) +
                        '<span class="margin-left-5 light-grey">' + '<i class="fa fa-star icon-button margin-right-5 margin-left-3 community-recommendation-color"></i>' +
                        templateSegmentRecommendation['recommendations'] + '</span>' +
                        '</div>';
                })
            } else {
                div += '<div class="display-block dark-grey">N/A</div>';
            }
            div += '</div>';

            $(".leaderboard-box").html(div);
            $('#leaderboard-container').hide().fadeIn();
            $(".leaderboard-box").scrollTop(0);
        });
    });

    // Show user info
    $("#user-info-menu-button, .user-display-name").on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        if (!globalUser.loggedIn) {
            playSoundEffect('error');
            notie.alert({type: 4, text: "You need to login to view User Info", stay: true});
            return false;
        }
        hideMainMenuContent($());
        makeGameRequest(getUserInfo, {}, showGetUserInfoData, {}, false);
    });

    // User Info
    $("#user-info-container").on('focus', '.user-info-display-name', function () {
        $('.save-user-info-display-name').show();
    });

    // Save user display name
    $("#user-info-container").on('click', '.save-user-info-display-name', function () {
        if (globals.requestRunning) {
            return false;
        }

        let name = $('.user-info-display-name').val();
        makeGetRequest('/_change_display_name', {name: name}, (data) => {
            if (!data['error']) {
                playSoundEffect('success');
                notie.alert({type: 4, text: 'Display Name Saved', stay: true});
                const user = loadUser();
                user.displayName = name;
                saveUser(user);
                showFormattedDisplayName(user);
            }
            else {
                playSoundEffect('error');
                if (data['error'] === 'display-name-already-exists') {
                    notie.alert({
                        type: 3,
                        text: "That display name is already in use. Please select a different name."
                    });
                }
                if (data['error'] === 'same') {
                    notie.alert({type: 3, text: "That is already your display name."});
                }
            }
        });
    });

    // Show settings
    $("#settings-menu-button").on('click', function () {
        playSoundEffect('success');
        hideMainMenuContent($());
        showSettingsPage();
    });

    // Apply user theme selection
    if (!user || (user && user.settings['theme'] !== 'light')) {
        $('.theme-settings-button').addClass('selected');
        document.getElementById('dark-theme').disabled = false;
    }
    else {
        $('.main-container').addClass('light');
        changeCharacterBackgroundImage('light');
    }

    // Theme input
    $("#settings-container").on('change', 'input[name="settings-theme-option"]', async function () {
        playSoundEffect('success');
        let theme;
        if ($(this).val() === 'light') {
            document.getElementById('dark-theme').disabled = true;
            theme = 'light';
            $('.main-container').addClass('light');
        }
        else {
            document.getElementById('dark-theme').disabled = false;
            theme = 'dark';
            $('.main-container').removeClass('light');
        }

        changeCharacterBackgroundImage(theme);
        await changeUserSettingRequest('theme', theme);
    });

    // Apply colorblind selection
    if (user && user.settings['colorblindMode']) {
        $('.colorblind-settings-button').addClass('selected');
        $("html").addClass("colorblind");
    }

    // Colorblind input
    $("#settings-container").on('change', 'input[name="settings-colorblind-mode-option"]', async function () {
        playSoundEffect('success');
        let colorblindMode;
        if ($(this).val() === 'off') {
            $("html").removeClass("colorblind");
            colorblindMode = false;
        }
        else {
            $("html").addClass("colorblind");
            colorblindMode = true;
        }

        await changeUserSettingRequest('colorblindMode', colorblindMode);
    });

    // Apply mobile view selection
    if (user && user.settings['mobileView']) {
        $(".display-settings-button").addClass('selected');
        $('html').attr('id', '');
        $('meta[name="viewport"]').prop('content', 'width=device-width, initial-scale=0.75');
    }

    // Mobile View input
    $("#settings-container").on('change', 'input[name="settings-display-mode-option"]', async function () {
        playSoundEffect('success');
        let mobileView;
        if ($(this).val() === 'desktop') {
            $('html').attr('id', 'widescreen');
            $('meta[name="viewport"]').prop('content', 'width=1440');
            mobileView = false;
        }
        else {
            $('html').attr('id', '');
            $('meta[name="viewport"]').prop('content', 'width=device-width, initial-scale=0.75');
            mobileView = true;
        }

        await changeUserSettingRequest('mobileView', mobileView);
    });

    // Activate free trial
    $('.activate-free-trial-button').click(function () {
        if (globals.requestRunning) {
            return false;
        }

        makeGetRequest('/_activate_free_trial', {}, async (data) => {
            if (data['trial_activated']) {
                playSoundEffect('success');
                notie.alert({
                    type: 4,
                    text: 'Your <span class="gold">JoW Paid</span> Free Trial has been activated! Have a look at all the ' +
                        '<a target="_blank" href="/jow-paid-features">unlocked features</a> and click <a href="/">here</a> ' +
                        'to go back to the game.',
                    stay: true
                });

                // Add paid features
                for (let gameData of JSON.parse(window.localStorage.getItem("jowGames")) || []) {
                    if (!gameData.scenarioId) {
                        await loadDb(gameData.dbUid);
                        const game = Games.find({})[0];
                        await addPaidFeatures(game);
                    }
                }
            }
            else {
                playSoundEffect('error');
                if (data['error'] === 'not-logged-in') {
                    notie.alert({
                        type: 3,
                        text: 'You need to be logged in to activate your Free Trial',
                        stay: true
                    });
                }
                if (data['error'] === 'already-paid') {
                    notie.alert({
                        type: 3,
                        text: 'You already have JoW Paid! What do you want, JoW Paid+?',
                        stay: true
                    });
                }
                if (data['error'] === 'already-activated-free-trial') {
                    notie.alert({
                        type: 3,
                        text: 'You have already activated your JoW Paid Free Trial',
                        stay: true
                    });
                }
            }
        });
    });

    // Login
    $('.button-login').click(function (e) {
        e.preventDefault();
        playSoundEffect('success');
        window.location.href = "/login";
    });

    // Logout
    $('.button-logout').click(function (e) {
        e.preventDefault();
        playSoundEffect('success');
        notie.confirm({
            text: 'Are you sure you want to logout?',
            submitText: 'Yes',
            cancelText: 'No',
            submitCallback: async function () {
                notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
                await syncUserData();
                firebase.auth().signOut().then(function () {
                    window.location.href = "/logout";
                }, function (error) {
                    console.error('Sign Out Error', error);
                    notie.alert({
                        type: 3,
                        text: 'An error occurred. Please try again.',
                        stay: true
                    });
                });
            }
        })
    });

    // Accept terms
    $('.accept-terms-button').on('click', function () {
        playSoundEffect('success');
        makeGetRequest('/_accept_terms', {}, (data) => {
            if (data) {
                $('#terms-container').hide();
            }
        });
    });

    // Upgrade
    $('.upgrade-button').on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        let key = $(".upgrade-key-input").val();

        makeGetRequest('/_check_key', {key: key}, (data) => {
            if (!data['error']) {
                playSoundEffect('success');
                notie.alert({
                    type: 4,
                    text: 'Thank you for buying JoW Paid! Your account has been upgraded. Click <a href="/">here</a> to go back to the game.',
                    stay: true
                });
                $(".upgrade-key-input").val('');
            }
            else {
                playSoundEffect('error');
                if (data['error'] === 'key-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'That key is not valid. Please make sure you copied the key correctly.',
                        stay: true
                    });
                }
                else if (data['error'] === 'not-logged-in') {
                    notie.alert({
                        type: 3,
                        text: 'Please <a href="/">login</a> to upgrade your account.',
                        stay: true
                    });
                }
                else if (data['error'] === 'already-paid') {
                    notie.alert({
                        type: 3,
                        text: 'Your account is already upgraded!',
                        stay: true
                    });
                }
            }
        });
    });

    // Close update container
    $('.close-update-container').on('click', function () {
        $('#update-container').hide();
    });

    // Redeem mobile key
    $('.redeem-mobile-button').on('click', function () {
        notie.alert({
            type: 3,
            text: 'Mobile keys will be available when the game releases on Mobile.',
            stay: true
        });
    });

    // Redeem steam key
    $('.redeem-steam-button').on('click', function () {
        if (globals.requestRunning) {
            return false;
        }

        makeGetRequest('/_redeem_steam_key', {}, (data) => {
            if (!data['error']) {
                playSoundEffect('success');
                notie.alert({
                    type: 4,
                    text: 'Key redeemed.'
                });
                $(".redeem-key-info").show();
                $(".redeemed-key").text(data['key']).show();
                $(".redeem-key-copy-button").show();
            }
            else {
                playSoundEffect('error');
                if (data['error'] === 'not-logged-in') {
                    notie.alert({
                        type: 3,
                        text: 'Please <a href="/">login</a> to upgrade your account.',
                        stay: true
                    });
                }
                else if (data['error'] === 'not-paid') {
                    notie.alert({
                        type: 3,
                        text: 'You have not activated JoW Paid on this account.',
                        stay: true
                    });
                }
                else if (data['error'] === 'post-steam-release') {
                    notie.alert({
                        type: 3,
                        text: 'Steam keys are only available for users who bought JoW Paid before the Steam release.',
                        stay: true
                    });
                }
                else if (data['error'] === 'already-redeemed') {
                    $(".redeem-key-info").show();
                    $(".redeemed-key").text(data['redeemed_key']).show();
                    $(".redeem-key-copy-button").show();
                }
                else if (data['error'] === 'key-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'No more keys could be found. Please wait as they are refreshed.',
                        stay: true
                    });
                }
            }
        });
    });

    // Copy key
    $('.redeem-key-copy-button').on('click', function () {
        copyToClipboard($(".redeemed-key"));
    });
});

async function setupUser() {
    // Load user from local storage
    let user = loadUser();

    // Load user data from jow db
    let jowUserData = $("#user-data").data("user-data");
    let protectedFunctionsError;
    if (jowUserData) {
        globalUser.paid = jowUserData.paid;
        globalUser.tester = jowUserData.tester;
        globalUser.freeTrialActivated = jowUserData.freeTrialActivated;
        globalUser.freeTrialActivatedDatetime = jowUserData.freeTrialActivatedDatetime;
        globalUser.loggedIn = true;
        Object.defineProperty(globalUser, "paid", { configurable: false, writable: false });
        Object.defineProperty(globalUser, "tester", { configurable: false, writable: false });

        // Setup protected functions for paid users
        if (globalUser.paid) {
            protectedFunctionsError = await setupProtectedFunctions();
            gameLimits.maxCompetitors = 19;
        }
        Object.defineProperty(gameLimits, "maxCompetitors", { configurable: false, writable: false });

        // Sync if same user
        if (user.uid === jowUserData.uid) {
            await syncUserData();
        }
        // Overwrite local user data if not set or different user
        else {
            user.eventsPlayed = jowUserData.eventsPlayed;
            user.unlockedSegments = jowUserData.unlockedSegments;
            user.storiesCompleted = jowUserData.storiesCompleted;
            user.talentRequestTypesCompleted = jowUserData.talentRequestTypesCompleted;
            user.unlockedPowerups = jowUserData.unlockedPowerups;
            user.unlockedCharacters = jowUserData.unlockedCharacters;
            user.unlockedCombinations = jowUserData.unlockedCombinations;
            user.uid = jowUserData.uid;
            user.displayName = jowUserData.displayName;
            user.settings = jowUserData.settings;
            user.updateVersionShown = jowUserData.updateVersionShown;
            if (user.settings['theme'] === 'light') {
                $('.theme-settings-button').removeClass('selected');
                document.getElementById('dark-theme').disabled = true;
            }
            saveUser(user);
        }
    }
    // Anonymous user
    else {
        // Show home page
        $('.main-container').hide();
        $('.about-container').show();

        // Show continue button if no games present
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        if (!userGames.length) {
            $('#continue-game').hide();
        }

        // Reset local user identifying data
        if (user.uid) {
            user.uid = null;
            user.displayName = null;
            saveUser(user);
        }
    }

    // Update user UI
    if (globalUser.paid) {
        if (globalUser.freeTrialActivated) {
            $('.account-level-text').text('Free Trial');
            $('.account-level-text').addClass('gold');
            $('.view-upgrade-button').show();
        } else {
            $('.account-level-text').text('Paid Version');
            $('.account-level-text').addClass('gold top-5px');
        }
    }
    else {
        $('.account-level-text').text('Free Version');
        $('.account-level-text').addClass('dark-grey');
        $('.view-upgrade-button').show();
    }
    if (globalUser.loggedIn) {
        showFormattedDisplayName(user);
        $('.button-logout').show();
    }
    else {
        $('.button-login').show();
    }

    $('.main-container').removeClass('blur');
    $('#container').removeClass('display-none');
    if (!protectedFunctionsError) {
        $('.notie-textbox').remove();
    }

    let notieTexts = '';

    // Update data
    const updateVersion = '5.3';
    let nonUpdateAlert = '';
    const now = Date.now();
    const saleEndDatetime = new Date('2024-06-12T23:00:00');
    if (now < saleEndDatetime) {
        const saleHoursRemaining = getTimeDiffHuman(saleEndDatetime, now);
        nonUpdateAlert =
            `JoW is now available on <a href="https://store.steampowered.com/app/2941580/?utm_source=website" target="_blank">Steam</a> with a 15% launch discount! Paid users can get a <a href="/redeem-steam" target="_blank">free key</a>.`
    }
    else {
        nonUpdateAlert = ``
    }

    // Non update alert
    if (nonUpdateAlert) {
        notieTexts += '<span class="display-block">' +
        nonUpdateAlert +
        '</span>';
    }

    if (jowUserData) {
        // Check free trial time remaining or end of trial
        if (jowUserData['freeTrialData']) {
            if (jowUserData['freeTrialData']['trial_ended']) {
                let freeTrialText = 'Your <span class="gold">JoW Paid</span> Free Trial has ended and paid features have been removed. If you enjoyed ' +
                    'playing it, you can upgrade permanently ' +
                    '<a href="https://www.humblebundle.com/widget/v2/product/jow_widget/sRm2uH4QdH?theme=light" ' +
                    'target="_blank">here</a>.';
                notieTexts += '<span class="display-block">' +
                    freeTrialText +
                    '</span>';

                // Remove paid features
                for (let gameData of JSON.parse(window.localStorage.getItem("jowGames")) || []) {
                    if (!gameData.scenarioId) {
                        await loadDb(gameData.dbUid);
                        const game = Games.find({})[0];
                        await removePaidFeatures(game);
                    }
                }
            }
            else {
                // Show free trial and time remaining
                let hoursRemaining = jowUserData['freeTrialData']['hours_remaining'];
                let hoursWord = (hoursRemaining === 1) ? 'hour' : 'hours';

                $('.account-level-text').addClass('help-text');
                if (hoursRemaining !== 0) {
                    $('.account-level-text').attr('title', '{0} {1} left'.format(hoursRemaining, hoursWord));
                }
                else {
                    let minutesRemaining = jowUserData['freeTrialData']['minutes_remaining'];
                    let minutesWord = (minutesRemaining === 1) ? 'minute' : 'minutes';
                    $('.account-level-text').attr('title', '{0} {1} left'.format(minutesRemaining, minutesWord));
                }
            }
        }

        // Show terms and conditions if not accepted
        if (!jowUserData['termsAndConditionsAccepted']) {
            $('#terms-container').show();
            $(".terms-content").load("terms");
        }

        // Show update container
        if (updateVersion !== user.updateVersionShown) {
            $('#update-container').show();
            user.updateVersionShown = updateVersion;
            saveUser(user);
        }
    }

    // Notify of other account
    const url = new URL(window.location.href);
    const otherAccountInfo = url.searchParams.get("other_account_info");
    if (otherAccountInfo) {
        let otherLoginName = (otherAccountInfo === 'google') ? 'Google' : 'Email/Password';
        let currentLoginName = (otherAccountInfo === 'google') ? 'Email/Password' : 'Google';
        notieTexts += 'Another account exists with this email. If you don\'t find your data on this account ({0}), please try logging into the other account ({1}).'.format(currentLoginName, otherLoginName);
    }

    if (notieTexts) {
        notie.alert({
            type: 4, text: notieTexts, stay: true
        });
    }

    return user;
}

function showDeleteGameRequestData({data, parent}) {
    if (!data['error']) {
        notie.alert({type: 4, text: "Game deleted"});
        parent.remove();
    }
    else {
        if (data['error'] === 'game-not-found') {
            notie.alert({type: 3, text: "That game could not be found. Please try again."});
        }
    }
}

function showGetUserInfoData({data}) {
    let eventsPlayed = data['eventsPlayed'];

    // Add special segments unlocked
    let unlockedSegmentsHtml = '';
    data['unlockedSegments'].forEach(function (unlockedSegment) {
        unlockedSegmentsHtml += '<div>' +
            unlockedSegment +
            '</div>';
    });
    if (data['unlockedSegments'].length < 1) {
        unlockedSegmentsHtml = '<div class="light-grey">None</div>'
    }
    let specialSegmentsTotal = 10;
    let specialSegmentsUnlockedNumber =
        '<span class="margin-left-5 special-segment-color">' +
        data['unlockedSegments'].length +
        '<span class="margin-left-2">/</span><span class="margin-left-2">' +
        specialSegmentsTotal +
        '</span>' +
        '</span>';

    // Add talent request types completed
    let talentRequestTypesCompletedHtml = '';
    data['talentRequestTypesCompletedData'].forEach(function (talentRequestCompleted) {
        talentRequestTypesCompletedHtml += '<div>' +
            talentRequestCompleted +
            '</div>';
    });
    if (data['talentRequestTypesCompletedData'].length < 1) {
        talentRequestTypesCompletedHtml = '<div class="light-grey">None</div>'
    }
    let talentRequestTypesCompletedNumber =
        '<span class="margin-left-5 green">' +
        data['talentRequestTypesCompletedData'].length +
        '<span class="margin-left-2">/</span><span class="margin-left-2">' +
        data['talentRequestTypesTotal'] +
        '</span>' +
        '</span>';

    if (data['displayName']) {
        $('.user-info-display-name').val(data['displayName']);
        $('.user-info-display-name').parent().show();
    }
    else {
        $('.user-info-display-name').parent().hide();
    }

    $('.user-info-events-played').html(eventsPlayed.toLocaleString('en'));
    $('.user-info-special-segments-unlocked').html(unlockedSegmentsHtml);
    $('.user-info-special-segments-unlocked-number').html(specialSegmentsUnlockedNumber);
    $('.user-info-talent-requests-completed').html(talentRequestTypesCompletedHtml);
    $('.user-info-talent-requests-completed-number').html(talentRequestTypesCompletedNumber);

    $('.save-user-info-display-name').hide();
    $("#user-info-container").hide().fadeIn();
    $('.user-info-box').scrollTop(0);
    $('.user-info-talent-requests-completed').scrollTop(0);
    $('.main-container').addClass('blur');
}

async function setupProtectedFunctions() {
    try {
        let {setManagersForMatchOrSegment, getRankingDataForYear, createFaction,
            createTalentRequest} = await import('../../../../app/protectedFunctions.js');
        setupSetManagersForMatchOrSegment(setManagersForMatchOrSegment);
        setupCreateFaction(createFaction);
        setupGetRankingDataForYear(getRankingDataForYear);
        setupCreateTalentRequest(createTalentRequest);
    }
    catch (error) {
        let notieText = 'There was an error loading some files. Please refresh.'
        if (!window.navigator.onLine) {
            notieText = 'It seems like you\'re offline. Please connect to the internet once to load the page.'
        }
        notie.alert({
            type: 3, text: notieText,
            stay: true
        });
        throw error;
    }
}

function showSettingsPage() {
    const user = loadUser();
    const $settingsContainer = $('#settings-container');

    if (!user || (user && user.settings['theme'] !== 'light')) {
        $settingsContainer.find('input[name="settings-theme-option"][value="dark"]').prop('checked', true)
    }
    else {
        $settingsContainer.find('input[name="settings-theme-option"][value="light"]').prop('checked', true)
    }

    if (user && user.settings['mobileView']) {
        $settingsContainer.find('input[name="settings-display-mode-option"][value="mobile"]').prop('checked', true)
    }
    else {
        $settingsContainer.find('input[name="settings-display-mode-option"][value="desktop"]').prop('checked', true)
    }

    if (user && user.settings['colorblindMode']) {
        $settingsContainer.find('input[name="settings-colorblind-mode-option"][value="on"]').prop('checked', true)
    }
    else {
        $settingsContainer.find('input[name="settings-colorblind-mode-option"][value="off"]').prop('checked', true)
    }

    $settingsContainer.hide().fadeIn();
    $('.main-container').addClass('blur');
}
